/* Keep offscreen product, collection and customer photos out of the initial load. */
(function () {
  'use strict';
  if (window.MurallsViewportImages) return;

  var selector = 'img[data-viewport-src]';
  var observed = new WeakSet();
  var resizeFrame = 0;
  var observer = createObserver('240px 0px');
  // Collection shoppers scroll through rows quickly. Start the next rows before
  // they appear, while retaining the smaller budget for other page galleries.
  var collectionObserver = createObserver('1000px 0px');

  function createObserver(rootMargin) {
    return typeof IntersectionObserver === 'function'
      ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.target.isConnected) hydrate(entry.target);
        });
      }, { rootMargin: rootMargin, threshold: 0 })
      : null;
  }

  function unobserve(image) {
    if (observer) observer.unobserve(image);
    if (collectionObserver) collectionObserver.unobserve(image);
  }

  function hydrate(image) {
    var source = image.getAttribute('data-viewport-src');
    if (!source) return;
    if (observer) {
      unobserve(image);
      // The image is now near the screen; do not apply a second lazy-load gate.
      image.loading = 'eager';
    }
    observed.delete(image);
    image.decoding = 'async';
    sizeGalleryImage(image);
    // Preserve sizes: the mobile swipe view may have adjusted it since render.
    var candidates = image.getAttribute('data-viewport-srcset');
    if (candidates) image.setAttribute('srcset', candidates);
    image.setAttribute('src', source);
    image.removeAttribute('data-viewport-srcset');
    image.removeAttribute('data-viewport-src');
  }

  function sizeGalleryImage(image) {
    if (!image.closest('media-gallery[data-fixed-frame] .product__media')) return;
    var width = Math.ceil(image.getBoundingClientRect().width);
    // Portrait slides can be much narrower than the whole gallery column.
    // Let srcset choose the right resolution for the actual slide and screen density.
    if (width > 0) image.setAttribute('sizes', width + 'px');
  }

  function visit(root, callback) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches(selector)) callback(root);
    root.querySelectorAll(selector).forEach(callback);
  }

  function observe(root) {
    visit(root, function (image) {
      if (observed.has(image)) return;
      var targetObserver = image.closest('#product-grid') ? collectionObserver : observer;
      if (!targetObserver) {
        // Native lazy loading remains a safe fallback without IntersectionObserver.
        hydrate(image);
        return;
      }
      observed.add(image);
      targetObserver.observe(image);
    });
  }

  function start() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    observe(main);
    // Facets replace the grid and Load more / For you append new cards.
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function (records) {
        records.forEach(function (record) {
          record.removedNodes.forEach(function (node) {
            visit(node, function (image) {
              if (image.isConnected) return;
              unobserve(image);
              observed.delete(image);
            });
          });
        });
        records.forEach(function (record) { record.addedNodes.forEach(observe); });
      }).observe(main, { childList: true, subtree: true });
    }
    main.addEventListener('focusin', function (event) {
      var card = event.target.closest('.card-wrapper, .collection-discovery__card, .pcg-card, .product__media-item, .product-design-tool');
      if (card) visit(card, hydrate);
    });
    window.addEventListener('resize', function () {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(function () {
        main.querySelectorAll('media-gallery[data-fixed-frame] .product__media img[data-viewport-image]:not([data-viewport-src])').forEach(sizeGalleryImage);
      });
    }, { passive: true });
  }

  window.MurallsViewportImages = { observe: observe, hydrate: hydrate };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
